module.exports = __webpack_public_path__ + "img/oneDrive.f7c118c2.svg";